<template>
  <fragment>
    <h2>모달 샘플</h2>
    <br />
    <br />
    <div style="padding-left:30px;">
      <button @click="testAlert">TEST ModalAlert 알림창</button>
      <br />
      <button @click="testConfirm">TEST ModalConfirm 확인창</button>
      <br />
      <button @click="testApplyDetail">TEST ModalApplyDetail 수강 신청상세</button>
      <br />
      <button @click="testClassStatus">TEST ModalClassStatus 수료관리</button>
      <br />
      <button @click="testEmailForm">TEST ModalEmailForm 이메일 양식 상세</button>
      <br />
      <button @click="testSentEmail">TEST ModalSentEmail 보낸 이메일 상세</button>
      <br />
      <button @click="testEmailFormRegister">TEST ModalEmailFormRegister 이메일 양식 등록</button>
      <br />
      <button @click="testInstitutionExcel">TEST ModalInstitutionExcel 기관 일괄등록</button>
      <br />
      <button @click="testInstitutionModify">TEST ModalInstitutionModify 기관수정</button>
      <br />
      <button @click="testInstitutionRegister">TEST ModalInstitutionRegister 기관등록</button>
      <br />
      <button @click="testInstitutionUnify">TEST ModalInstitutionUnify 기관통합</button>
      <br />
      <button @click="testNewClass">TEST ModalNewClass 강의만들기</button>
      <br />
      <button @click="testAssignTeacher">TEST ModalAssignTeacher 강사배정</button>
      <br />
      <button @click="testUserRegister">TEST ModalUserRegister 회원등록</button>
      <br />
      <button @click="testUserRegisterExcel">TEST ModalUserRegisterExcel 회원 일괄등록</button>
      <br />
      <button @click="testUserUnify">TEST ModalUserUnify 회원통합</button>
      <br />
      <button @click="testSms">TEST ModalSms 문자보내기</button>
      <br />
      <button @click="testEmail">TEST ModalEmail 메일보내기</button>
      <br />
      <button @click="testExamRegister">TEST ModalExamRegister 시험문항 등록</button>
      <br />
      <button @click="testExamModify">TEST ModalExamModify 시험문항 수정</button>
      <br />
      <button @click="testExamDetail">TEST ModalExamDetail 시험문항 상세</button>
      <br />
      <button @click="testExamRegisterExcel">TEST ModalExamRegisterExcel 시험문항 일괄등록</button>
      <br />
      <button @click="testSurveyRegister">TEST ModalESurveyegister 설문문항 등록</button>
      <br />
      <button @click="testSurveyModify">TEST ModalSurveyModify 설문문항 수정</button>
      <br />
      <button @click="testSurveyDetail">TEST ModalSurveyDetail 설문문항 상세</button>
      <br />
      <button @click="testSurveyRegisterExcel">TEST ModalSurveyRegisterExcel 설문문항 일괄등록</button>
      <br />
      <button @click="testPopupRegister">TEST ModalPopupRegister 팝업 만들기</button>
      <br />
      <button @click="testPopupModify">TEST ModalPopupModify 팝업 수정</button>
      <br />
      <button @click="testExamAppend">TEST ModalExamAppend 시험문항 불러오기</button>
    </div>

    <modal-confirm
      :config="confirm"
      :key="hash(confirm)"
      @yes="confirm.show=false"
      @no="confirm.show=false"
    ></modal-confirm>
    <modal-alert :config="alert" :key="hash(alert)" @close="alert.show=false"></modal-alert>
    <modal-apply-detail
      :config="applyDetail"
      :key="hash(applyDetail)"
      @close="applyDetail.show=false"
    ></modal-apply-detail>
    <modal-class-status
      :config="classStatus"
      :key="hash(classStatus)"
      @close="classStatus.show=false"
    ></modal-class-status>
    <modal-email-form :config="emailForm" :key="hash(emailForm)" @close="emailForm.show=false"></modal-email-form>
    <modal-email-form-register
      :config="emailFormRegister"
      :key="hash(emailFormRegister)"
      @close="emailFormRegister.show=false"
    ></modal-email-form-register>
    <modal-sent-email :config="sentEmail" :key="hash(sentEmail)" @close="sentEmail.show=false"></modal-sent-email>
    <modal-institution-excel
      :config="institutionExcel"
      :key="hash(institutionExcel)"
      @close="institutionExcel.show=false"
    ></modal-institution-excel>
    <modal-institution-modify
      :config="institutionModify"
      :key="hash(institutionModify)"
      @close="institutionModify.show=false"
    ></modal-institution-modify>
    <modal-institution-register
      :config="institutionRegister"
      :key="hash(institutionRegister)"
      @close="institutionRegister.show=false"
    ></modal-institution-register>
    <modal-institution-unify
      :config="institutionUnify"
      :key="hash(institutionUnify)"
      @close="institutionUnify.show=false"
    ></modal-institution-unify>
    <modal-new-class :config="newClass" :key="hash(newClass)" @close="newClass.show=false"></modal-new-class>
    <modal-assign-teacher
      :config="assignTeacher"
      :key="hash(assignTeacher)"
      @close="assignTeacher.show=false"
    ></modal-assign-teacher>
    <modal-user-register
      :config="userRegister"
      :key="hash(userRegister)"
      @close="userRegister.show=false"
    ></modal-user-register>
    <modal-user-register-excel
      :config="userRegisterExcel"
      :key="hash(userRegisterExcel)"
      @close="userRegisterExcel.show=false"
    ></modal-user-register-excel>
    <modal-user-unify :config="userUnify" :key="hash(userUnify)" @close="userUnify.show=false"></modal-user-unify>
    <modal-sms :config="sms" :key="hash(sms)" @close="sms.show=false"></modal-sms>
    <modal-email :config="email" :key="hash(email)" @close="email.show=false"></modal-email>
    <modal-exam-register
      :config="examRegister"
      :key="hash(examRegister)"
      @close="examRegister.show=false"
    ></modal-exam-register>
    <modal-exam-modify :config="examModify" :key="hash(examModify)" @close="examModify.show=false"></modal-exam-modify>
    <modal-exam-register-excel
      :config="examRegisterExcel"
      :key="hash(examRegisterExcel)"
      @close="examRegisterExcel.show=false"
    ></modal-exam-register-excel>
    <modal-exam-detail :config="examDetail" :key="hash(examDetail)" @close="examDetail.show=false"></modal-exam-detail>
    <modal-survey-register
      :config="surveyRegister"
      :key="hash(surveyRegister)"
      @close="surveyRegister.show=false"
    ></modal-survey-register>
    <modal-survey-modify
      :config="surveyModify"
      :key="hash(surveyModify)"
      @close="surveyModify.show=false"
    ></modal-survey-modify>
    <modal-survey-register-excel
      :config="surveyRegisterExcel"
      :key="hash(surveyRegisterExcel)"
      @close="surveyRegisterExcel.show=false"
    ></modal-survey-register-excel>
    <modal-survey-detail
      :config="surveyDetail"
      :key="hash(surveyDetail)"
      @close="surveyDetail.show=false"
    ></modal-survey-detail>
    <modal-popup-register
      :config="popupRegister"
      :key="hash(popupRegister)"
      @close="popupRegister.show=false"
    ></modal-popup-register>
    <modal-popup-modify
      :config="popupModify"
      :key="hash(popupModify)"
      @close="popupModify.show=false"
    ></modal-popup-modify>
    <modal-exam-append :config="examAppend" :key="hash(examAppend)" @close="examAppend.show=false"></modal-exam-append>
  </fragment>
</template>

<script>
import ModalAlert from "../modals/ModalAlert.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";
import ModalApplyDetail from "../modals/ModalApplyDetail.vue";
import ModalClassStatus from "../modals/ModalClassStatus.vue";
import ModalEmailForm from "../modals/ModalEmailForm.vue";
import ModalSentEmail from "../modals/ModalSentEmail.vue";
import ModalEmailFormRegister from "../modals/ModalEmailFormRegister.vue";
import ModalInstitutionExcel from "../modals/ModalInstitutionExcel.vue";
import ModalInstitutionModify from "../modals/ModalInstitutionModify.vue";
import ModalInstitutionRegister from "../modals/ModalInstitutionRegister.vue";
import ModalInstitutionUnify from "../modals/ModalInstitutionUnify.vue";
import ModalNewClass from "../modals/ModalNewClass.vue";
import ModalAssignTeacher from "../modals/ModalAssignTeacher.vue";
import ModalUserRegister from "../modals/ModalUserRegister.vue";
import ModalUserRegisterExcel from "../modals/ModalUserRegisterExcel.vue";
import ModalUserUnify from "../modals/ModalUserUnify.vue";
import ModalSms from "../modals/ModalSms.vue";
import ModalEmail from "../modals/ModalEmail.vue";
import ModalExamRegister from "../modals/ModalExamRegister.vue";
import ModalExamRegisterExcel from "../modals/ModalExamRegisterExcel.vue";
import ModalExamModify from "../modals/ModalExamModify.vue";
import ModalExamDetail from "../modals/ModalExamDetail.vue";
import ModalSurveyRegister from "../modals/ModalSurveyRegister.vue";
import ModalSurveyRegisterExcel from "../modals/ModalSurveyRegisterExcel.vue";
import ModalSurveyModify from "../modals/ModalSurveyModify.vue";
import ModalSurveyDetail from "../modals/ModalSurveyDetail.vue";
import ModalPopupRegister from "../modals/ModalPopupRegister.vue";
import ModalPopupModify from "../modals/ModalPopupModify.vue";
import ModalExamAppend from "../modals/ModalExamAppend.vue";

export default {
  name: "ModalSamples",

  components: {
    ModalAlert,
    ModalConfirm,
    ModalApplyDetail,
    ModalClassStatus,
    ModalEmailForm,
    ModalEmailFormRegister,
    ModalSentEmail,
    ModalInstitutionExcel,
    ModalInstitutionModify,
    ModalInstitutionRegister,
    ModalInstitutionUnify,
    ModalNewClass,
    ModalAssignTeacher,
    ModalUserRegister,
    ModalUserRegisterExcel,
    ModalUserUnify,
    ModalSms,
    ModalEmail,
    ModalExamRegister,
    ModalExamRegisterExcel,
    ModalExamModify,
    ModalExamDetail,
    ModalSurveyRegister,
    ModalSurveyRegisterExcel,
    ModalSurveyModify,
    ModalSurveyDetail,
    ModalPopupRegister,
    ModalPopupModify,
    ModalExamAppend
  },

  data: function() {
    return {
      alert: ModalAlert.default(), // 알림모달 설정객체 기본값
      confirm: ModalConfirm.default(), // 확인모달 설정객체 기본값
      applyDetail: ModalApplyDetail.default(), // 수강 신청상세모달 설정객체 기본값
      classStatus: ModalClassStatus.default(), // 수료관리모달 설정객체 기본값
      emailForm: ModalEmailForm.default(), // 이메일양식보기모달 설정객체 기본값
      emailFormRegister: ModalEmailFormRegister.default(), // 이메일양식작성하기모달 설정객체 기본값
      institutionExcel: ModalInstitutionExcel.default(), // 기관일괄등록모달 설정객체 기본값
      institutionModify: ModalInstitutionModify.default(), // 기관수정모달 설정객체 기본값
      institutionRegister: ModalInstitutionRegister.default(), // 기관등록모달 설정객체 기본값
      institutionUnify: ModalInstitutionUnify.default(), // 기관통합모달 설정객체 기본값
      newClass: ModalNewClass.default(), // 강의만들기모달 설정객체 기본값
      sentEmail: ModalSentEmail.default(), // 보낸이메일상세모달 설정객체 기본값
      assignTeacher: ModalAssignTeacher.default(), // 강사배정모달 설정객체 기본값
      userRegister: ModalUserRegister.default(), // 회원등록모달 설정객체 기본값
      userRegisterExcel: ModalUserRegisterExcel.default(), // 회원일괄등록모달 설정객체 기본값
      userUnify: ModalUserUnify.default(), // 회원통합모달 설정객체 기본값
      sms: ModalSms.default(), // 문자보내기모달 설정객체 기본값
      email: ModalEmail.default(), // 메일보내기모달 설정객체 기본값
      examRegister: ModalExamRegister.default(), // 시험문항등록모달 설정객체 기본값
      examRegisterExcel: ModalExamRegisterExcel.default(), // 시험문항일괄등록모달 설정객체 기본값
      examModify: ModalExamModify.default(), // 시험문항수정모달 설정객체 기본값
      examDetail: ModalExamDetail.default(), // 시험문항상세모달 설정객체 기본값
      surveyRegister: ModalSurveyRegister.default(), // 설문문항등록모달 설정객체 기본값
      surveyRegisterExcel: ModalSurveyRegisterExcel.default(), // 설문문항일괄등록모달 설정객체 기본값
      surveyModify: ModalSurveyModify.default(), // 설문문항수정모달 설정객체 기본값
      surveyDetail: ModalSurveyDetail.default(), // 설문문항상세모달 설정객체 기본값
      popupRegister: ModalPopupRegister.default(), // 팝업만들기모달 설정객체 기본값
      popupModify: ModalPopupModify.default(), // 팝업수정모달 설정객체 기본값
      examAppend: ModalExamAppend.default() // 시험관리모달 설정객체 기본값
    };
  },

  methods: {
    // 알림모달 테스트
    testAlert: function() {
      this.alert.msg = "알림모달 테스트 메시지";
      this.alert.show = true;
    },

    // 확인모달 테스트
    testConfirm: function() {
      this.confirm.msg = "확인모달 테스트 메시지. 이게 잘 보입니까?";
      this.confirm.show = true;
    },

    // 수강 신청상세모달 테스트
    testApplyDetail: function() {
      this.applyDetail.show = true;
    },

    // 수료관리모달 테스트
    testClassStatus: function() {
      this.classStatus.show = true;
    },

    // 이메일양식보기모달 테스트
    testEmailForm: function() {
      this.emailForm.show = true;
    },

    // 보낸이메일상세모달 테스트
    testSentEmail: function() {
      this.sentEmail.show = true;
    },

    // 이메일양식작성하기모달 테스트
    testEmailFormRegister: function() {
      this.emailFormRegister.show = true;
    },

    // 기관일괄등록모달 테스트
    testInstitutionExcel: function() {
      this.institutionExcel.show = true;
    },

    // 기관수정모달 테스트
    testInstitutionModify: function() {
      this.institutionModify.show = true;
    },

    // 기관등록모달 테스트
    testInstitutionRegister: function() {
      this.institutionRegister.show = true;
    },

    // 기관통합모달 테스트
    testInstitutionUnify: function() {
      this.institutionUnify.show = true;
    },

    // 강의만들기모달 테스트
    testNewClass: function() {
      this.newClass.show = true;
    },

    // 강사배정모달 테스트
    testAssignTeacher: function() {
      this.assignTeacher.show = true;
    },

    // 회원등록모달 테스트
    testUserRegister: function() {
      this.userRegister.show = true;
    },

    // 회원일괄등록모달 테스트
    testUserRegisterExcel: function() {
      this.userRegisterExcel.show = true;
    },

    // 회원통합모달 테스트
    testUserUnify: function() {
      this.userUnify.show = true;
    },

    // 문자보내기모달 테스트
    testSms: function() {
      this.sms.show = true;
    },

    // 메일보내기모달 테스트
    testEmail: function() {
      this.email.show = true;
    },

    // 시험문항등록모달 테스트
    testExamRegister: function() {
      this.examRegister.show = true;
    },

    // 시험문항일괄등록모달 테스트
    testExamRegisterExcel: function() {
      this.examRegisterExcel.show = true;
    },

    // 시험문항수정모달 테스트
    testExamModify: function() {
      this.examModify.show = true;
    },

    // 시험문항상세모달 테스트
    testExamDetail: function() {
      this.examDetail.show = true;
    },

    // 설문문항등록모달 테스트
    testSurveyRegister: function() {
      this.surveyRegister.show = true;
    },

    // 설문문항일괄등록모달 테스트
    testSurveyRegisterExcel: function() {
      this.surveyRegisterExcel.show = true;
    },

    // 설문문항수정모달 테스트
    testSurveyModify: function() {
      this.surveyModify.show = true;
    },

    // 설문문항상세모달 테스트
    testSurveyDetail: function() {
      this.surveyDetail.show = true;
    },

    // 팝업만들기모달 테스트
    testPopupRegister: function() {
      this.popupRegister.show = true;
    },

    // 팝업수정모달 테스트
    testPopupModify: function() {
      this.popupModify.show = true;
    },

    // 시험문항불러오기 모달 테스트
    testExamAppend: function() {
      this.examAppend.show = true;
    }
  }
};
</script>